import getCursorPosInBlock from './getCursorPosInBlock';

export default ({ editor }) => {
  const {
    value: {
      selection: { isCollapsed, isExpanded },
      focusBlock,
    },
  } = editor;

  const { isFocusAtBeginning, isFocusAtEnd, isInBetween } = getCursorPosInBlock(
    { editor },
  );

  const nativeSelection = window.getSelection().toString().length;

  if (isCollapsed && !isExpanded && !nativeSelection) {
    if (isFocusAtBeginning) {
      editor.moveFocusWordForward(focusBlock);
      editor.moveAnchorToStartOfNode(focusBlock);
    } else if (isInBetween) {
      editor.moveFocusWordForward(focusBlock);
      editor.moveAnchorWordBackward(focusBlock);
    } else if (isFocusAtEnd) {
      editor.moveAnchorWordBackward(focusBlock);
      editor.moveFocusToEndOfNode(focusBlock);
    }
  }
};
